<template>
    <div class="nav">
        <LoginComponent v-if="login"></LoginComponent>
        <WxLoginComponent v-if="wxlogin"></WxLoginComponent>
        <RegistComponent v-if="regist"></RegistComponent>
        <!-- <div class="header-box"> -->
            <div class="nav-header content-container">
                <img class="logo" :src="logo_img" alt="北京汉伦管理咨询有限公司"/>
                <div class="header-right">
                    <div class="valign right-top">
                        <img style="width:1.7rem;height:1.4rem;" :src="tel_img" />
                        <span class="right-time">周一至周五  9:00-18:00</span>
                    </div>
                    <div>
                        <!-- <span class="right-en">中文/En</span> -->
                        <span class="right-tel">8610 - 8418 5298</span>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <div class="navul">
            <ul class="content-container ul">
                <router-link tag="li" :class="[index == 0 ? 'li active' : 'li']" to="/" exact>首页</router-link>
                <li :class="[index == 1 && lineShow  ? 'li active' : 'li']" @mouseover="pushShow" @mouseout="pushHide" style="width:10rem;" >汉伦投资管理
                    <ul ref="ul" @mouseout="pushHide" class="sub-ul">
                        <img :src="nav_img" class="sub-row" />
                        <router-link tag="a"  class="sub-li" to="/houseList/1">高端新楼盘</router-link>
                        <router-link tag="a" class="sub-li" to="/houseList/2">精品现房</router-link>
                    </ul>
                </li>
                <li :class="[index == 2 && lineShow ? 'li active' : 'li']" @mouseover="rentShow" @mouseout="rentHide"  style="width:10rem;" exact>汉伦直租
                    <ul ref="rent" @mouseout="rentHide" class="sub-ul">
                        <img :src="nav_img" class="sub-row" />
                        <router-link tag="li" class="sub-li" to="/directRent">优质房源</router-link>
                        <router-link tag="li" class="sub-li" to="/Procedure">租房流程</router-link>
                        <a class="sub-li" href="http://report.hanlandglobal.com" target="_blank">报修系统</a>
                    </ul>
                </li>
                <li :class="[index == 3 && lineShow ? 'li active' : 'li']" @mouseover="manageShow" @mouseout="manageHide" style="width:10rem;">汉伦基业
                    <ul ref="manageul" @mouseout="manageHide" class="sub-ul">
                        <img :src="nav_img" class="sub-row" />
                        <router-link tag="li"  class="sub-li" to="/management">汉伦物业管理</router-link>
                        <router-link tag="li"  class="sub-li" to="/management/step">服务内容介绍</router-link>
                        <!-- <router-link tag="li" class="sub-li" to="/BrandStory">品牌故事</router-link> -->
                        <!-- <router-link tag="li" class="sub-li" to="/moveHouse">附加服务</router-link> -->
                    </ul>
                </li>
                <li :class="[index == 4 && lineShow ? 'li active' : 'li']" @mouseover="aboutShow" @mouseout="aboutHide" style="width:10rem;" >关于汉伦
                    <ul ref="about" @mouseout="aboutHide" class="sub-ul">
                        <img :src="nav_img" class="sub-row" />
                        <router-link tag="li"  class="sub-li" to="/about">公司介绍</router-link>
                        <router-link tag="li"  class="sub-li" to="/contact">联系我们</router-link>
                    </ul>
                </li>
                <!-- <li class="li login" @click="loginShow"><img class="login-img" :src="login_img"/></li> -->
            </ul>
        </div>
        <van-nav-bar class="mobile-nav" title="汉伦"  @click-right="openBar()" @click-left="goBlack()" placeholder fixed :z-index="999999" safe-area-inset-top>
            <template #left>
                <van-icon name="arrow-left" color="#0e2d57" size="18"/>
            </template>
            <template #right>
                <van-icon name="ellipsis" color="#0e2d57" size="18"/>
            </template>
        </van-nav-bar>
        <van-popup v-model="show" position="right"  :style="{ width: '32%',height: '100%'}">
            <van-sidebar v-model="activeKey" @change="onChange">
                <van-sidebar-item title="首页" to="/"/>
                <van-sidebar-item title="高新楼盘" to="/houseList/1"/>
                <van-sidebar-item title="精品现房" to="/houseList/2"/>
                <van-sidebar-item title="优质房源" to="/directRent"/>
                <van-sidebar-item title="租房流程" to="/Procedure"/>
                <van-sidebar-item title="报修系统" url="http://report.hanlandglobal.com"/>
                <van-sidebar-item title="物业管理" to="/management"/>
                <van-sidebar-item title="服务介绍" to="/management/step"/>
                <van-sidebar-item title="公司介绍" to="/about"/>
                <van-sidebar-item title="联系我们" to="/contact"/>
            </van-sidebar>
        </van-popup>
    </div>
</template>
<script>

import logo_img from '@assets/image/index/logo.png'
import tel_img from '@assets/image/icon/tel.png'
// import login_img from '@assets/image/icon/parson.png'
import nav_img from '@assets/image/icon/nav-row.png'
import LoginComponent from '@components/user/LoginComponent'
import WxLoginComponent from '@components/user/WXLoginComponent'
import RegistComponent from '@components/user/RegistComponent'


export default {
    name:'NavComponent',
    props:['index'],
    components:{
        LoginComponent,
        WxLoginComponent,
        RegistComponent,
    },
    data() {
        return {
            logo_img,
            tel_img,
            activeKey:0,
            // login_img,
            nav_img,
            show:false,
            login:false,
            wxlogin:false,
            regist:false,
            lineShow:true
        }
    },
    mounted(){
      let index =  sessionStorage.getItem('navIndex') || ''
      this.activeKey = index;
    },
    methods:{
        pushShow(){
            this.$refs.ul.style.display="block"
            this.lineShow = false
        },
        pushHide(){
            this.$refs.ul.style.display="none"
            this.lineShow = true
        },
        rentShow(){
            this.$refs.rent.style.display="block"
            this.lineShow = false
        },
        rentHide(){
            this.$refs.rent.style.display="none"
            this.lineShow = true
        },
        manageShow(){
            this.$refs.manageul.style.display="block"
            this.lineShow = false
        },
        manageHide(){
            this.$refs.manageul.style.display="none"
            this.lineShow = true
        },
        aboutShow(){
            this.$refs.about.style.display="block"
            this.lineShow = false
        },
        aboutHide(){
            this.$refs.about.style.display="none"
            this.lineShow = true
        },
        loginShow(){
            this.login = true
        },
        loginHide(){
            this.login = false
        },
        wxloginShow(){
            this.wxlogin = true
            this.login = false
        },
        wxloginHide(){
            this.wxlogin = false
        },
        registHide(){
            this.regist = false
        },
        registShow(){
            this.regist = true
            this.login = false
        },
        openBar(){
            this.show = true;
        },
        goBlack(){
            this.$router.go(-1)
        },
        onChange(index){
            sessionStorage.setItem('navIndex',index)
        }
    }
}
</script>
<style lang="scss" scoped>
.nav{
    // width: 100%;
    // height: 10.9rem;
    // position: relative;
}
.nav-header{
    height: 7rem;
    display: flex;
    padding-top:2rem;
    background: #fff;
    justify-content: space-between;
}
// .header-box{
//     height: 7rem;
//     width: 100%;
//     background: #fff;
//     position: fixed;
//     top: 0;
//     z-index: 999999;
// }
.mobile-nav{
    display:none;
}
.logo{
    width: 7.5rem;
    height: 3.9rem;
}
.right-top{
    margin-left: 5.2rem;
}
.right-time{
    color: #1a284b;
    font-size: 0.9rem;
    margin-left: 1.6rem;
    line-height: 1rem;
    text-align: right;
}
.right-en{
	font-family: MicrosoftYaHei;
	font-size: 1rem;
	line-height: 1rem;
	letter-spacing: 0px;
	color: #3a4a5b;
}
.right-tel{
    font-family: DINAlternate-Bold;
    font-weight: 700;
	font-size: 1.5rem;
    letter-spacing: 0px;
    margin-left: 5.2rem;
	color: #1a284b;
}
.navul{
    width: 100%;
    height:3.9rem;  
    background: $color;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    // position: fixed;
    // top: 7rem;
    // z-index: 999999;
}
.ul{
    display: flex;
    padding-left: 2.5rem;
    justify-content: space-between;
}
.li{
    // width: 5rem;
    font-family: MicrosoftYaHei;
	font-size: 1.1rem;
	letter-spacing: 0.05rem;
    color: #ffffff;
    text-align: center;
    line-height:3.9rem ;
    position: relative;
}
.active::after{
    content: '';
    position: absolute;
    top: 3.7rem;
    right: 50%;
    left: 50%;
    margin-left: -1rem;
    width: 2rem;
    height: 0.2rem;
    background:#a22915;
}
.sub-ul{
    width: 10rem;
    position: relative;
    display: none;
    z-index: 999;
    padding-top: 0.6rem;
    box-sizing: border-box;
    background:rgba($color: $color, $alpha: 0.5);
    a{
        color: #fff;
    }
}
.sub-li{
    line-height: 2.5rem;
    display: block;
    padding: 0;
}
.sub-li:hover{
    background:rgba($color: $color, $alpha: 0.5);
}
.sub-ul .sub-row{
    width: 1.3rem;
    height: 0.6rem;
    display: block;
    right: 4.3rem;
    line-height:0rem ;
    position: absolute;
    top: 0;
}
.login{
    width: 4.2rem;
    height: 100%;
    background: $bgcolor;
}
@media only screen and (max-width: 1024px){
    .nav-header{
        display: none;
    }
    .mobile-nav{
        display:block;
    }
    .navul{
        display: none;
    }
    .nav{
        .van-sidebar{
            width: 90%;
            margin: 50px auto 0;
        }
        .van-nav-bar__title{
            color: #0e2d57;
        }
    }
}
</style>